<template>
  <div id="classify">
    <el-card class="box-card">
        <div slot="header" class="clearfix">
            <span>商品管理&nbsp;/&nbsp;商品分类</span>
        </div>
        <div style="display: flex;flex-wrap: wrap;align-items: center;">
            <Provinces @gain='gainSS'></Provinces>
           <!-- <el-input class="elinputs" v-model="beginData.id" placeholder="分类编号"></el-input> -->
           <el-input class="elinputs" v-model="beginData.name" placeholder="分类名称"></el-input>
            <el-select v-model="beginData.isShow" placeholder="是否显示" class="elinputs">
                <el-option v-for="item in beginData.isShows" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
            </el-select>
            <!--<el-input style="width: 216px;margin-right:16px;" v-model="beginData.id" placeholder=" 搜索编号"></el-input> -->
            <el-button style="margin-right:16px;" type="primary" element-loading-text="加载中..." element-loading-background="rgba(0, 0, 0, 0.4)" v-loading.fullscreen.lock="fullscreenLoading" @click="query">查询</el-button>
            <el-button type="info" @click='resets'>重置</el-button>
        </div>
        <div class="tit">
            <Reset @clkBtn='theBtn'></Reset>
            <Xlsx :name="formname"></Xlsx>
        </div>
        <el-table :data="tableData" id="exportTab" @selection-change="handleSelectionChange" border stripe style="width: 100%">
            <el-table-column type="selection" width="60"></el-table-column>
            <el-table-column type="index" label="序号" width="80" :index="1"></el-table-column>
            <el-table-column prop="name" label="分类名称" min-width="130"></el-table-column>

            <el-table-column label="分类图标" width="200">
                <template slot-scope="scope">
                    <viewer>
                        <img class="sfzimg" :src="imgUrl+scope.row.iconUrl" />
                    </viewer>
                </template>
            </el-table-column>
            <el-table-column label="分类图片" width="200">
                <template slot-scope="scope">
                    <viewer>
                        <img class="sfzimg" :src="imgUrl+scope.row.picUrl" />
                    </viewer>
                </template>
            </el-table-column>
            <el-table-column prop="areasName" label="所属地区" min-width="160"></el-table-column>
            <el-table-column prop="sortOrder" label="排序" sortable width="100"></el-table-column>
            <el-table-column label="是否显示" width="130">
                <template slot-scope="scope">
                    <p class="boldfont" v-if="scope.row.isShow" style="color:#67C23A">是</p>
                    <p class="boldfont" v-else style="color:#F56C6C">否</p>
                </template>
            </el-table-column>
            <el-table-column prop="addTime" label="添加时间" min-width="180"></el-table-column>
            <el-table-column prop="updateTime" label="修改时间" width="180"></el-table-column>
            <el-table-column label="操作" fixed="right" width="220">
                <template slot-scope="scope">
                <el-button size="mini" type="success" @click="handleEdit(1,scope.row,'classify:update')"><i class="el-icon-edit"></i> 编辑</el-button>
                <el-button size="mini" type="danger" @click="stop(scope.row,'classify:delete')"><i class="el-icon-delete"></i> 删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="paging">
            <span>
            共
            <i class="pagingNum">{{total}}</i> 条
            </span>
            <Paging :gopage="total" @pag="pag"></Paging>
        </div>
    </el-card>
    <el-dialog title="添加/编辑" :visible.sync="dialogFormVisible" width="60%" @close="dataClose">
        <el-form>
            <el-form-item label="* 所属地区：">
                <el-select v-model="sheng" placeholder="省份" @change="cksheng">
                    <el-option
                    v-for="item in shenglist"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                    </el-option>
                </el-select>
                <el-select v-model="shi" placeholder="城市" @change="ckshi" class="cty16">
                    <el-option
                    v-for="item in shilist"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="* 分类名称：">
               <el-input placeholder="请输入分类名称（建议最多6个字，小程序端显示效果最佳）" v-model="mydata.name" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="* 分类图标：" style='margin-bottom: 10px;'>
                <el-upload class="upload-demo" :action="URL" :limit="1" :on-remove="handleRemove" ref="upload" :on-success="handleAvatarSuccess" :data="newobj" :file-list="mydata.iconUrls" name="multipartFile" :headers="newhead" list-type="picture">
                    <el-button size="small" type="primary">点击上传</el-button>
                    <div slot="tip" class="el-upload__tip">选择分类图标，推荐尺寸200*200px，大小100k以内</div>
                </el-upload>
            </el-form-item>
            <el-form-item label="* 分类图片：" style='margin-bottom: 10px;'>
                <el-upload class="upload-demo" :action="URL" :limit="1" :on-remove="handleRemove1" ref="uploads" :on-success="handleAvatarSuccess1" :data="newobj" :file-list="mydata.picUrls" name="multipartFile" :headers="newhead" list-type="picture">
                    <el-button size="small" type="primary">点击上传</el-button>
                    <div slot="tip" class="el-upload__tip">选择分类图片，推荐尺寸800*600px，大小100k以内</div>
                </el-upload>
            </el-form-item>
            <el-form-item label="* 排序：">
               <el-input type="number" placeholder="数字越大，排名越靠前（请输入正整数）" v-model="mydata.sortOrder" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="* 是否上架：">
                <el-radio v-model="mydata.isShow" label=true>是</el-radio>
                <el-radio v-model="mydata.isShow" label=false>否</el-radio>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible=false">取 消</el-button>
            <el-button type="primary" @click="puton(2)">确 定</el-button>
        </div>
    </el-dialog>
  </div>
</template>
<script>
import Provinces from "@/components/Provinces";
import Reset from "@/components/Reset";
import Xlsx from "@/components/Xlsx";
import EditorBar from '@/components/Richtext'
import Paging from '@/components/Paging';
export default {
  name: "classify",
  components: {
    Xlsx,
    EditorBar,
    Provinces,
    Reset,
    Paging
  },
  data() {
    return {
        beginData:{
            isShows:[{id:1,name:'是'},{id:0,name:'否'}],
        },
        tableData: [],
        pageNum: 1,
        pageSize: 10,
        dialogFormVisible: false,
        userdata: {},
        total: 0,
        btn: [],
        fullscreenLoading: true,
        formname:JSON.stringify({name:'商品分类',hint:'classify:update'}),
        imgUrl: this.$Public.imgUrl,
        sheng:'',
        shi:'',
        shenglist:[],
        shilist:[],
        mydata:{isShow:'true'},
        multipleSelection:[],
        URL:`${this.$Public.URL}/api-r/upload/uploadImg`,
        videoURL:`${this.$Public.URL}/api-e/upload/uploadVideo`,
        newobj:{type:3},
        newhead:{
                accessToken:JSON.parse(sessionStorage.getItem('userdata')).token
        },
    };
  },
  created() {
    let btn = JSON.parse(sessionStorage.getItem("btn"));
    this.$set(this, "btn", btn);
    this.begin();
  },
  computed: {
    data() {
      return this.tableData;
    }
  },
  mounted() {
    let region = JSON.parse(localStorage.getItem('region'))
    region.forEach(x => {
        if(x.level==0){
            this.shenglist.push(x)
            this.sheng=x.id
        }
    });
    if(this.userdata.level==0){
        this.$axios.post(`/api-r/area/getSubordinateAreaList`,this.$qs.stringify({areasId:region[0].id}),{headers:{accessToken:this.userdata.token}})
        .then(res=>{
            if(res.data.success){
                this.$set(this,'shilist',res.data.areaListInfoList)
            }
        })
    }else{
        region.forEach(x=>{
            if(x.level==1){
                this.shilist.push(x)
            }
        })
        if(this.shilist.length==1){
            this.shi=this.shilist[0].id
            this.mydata.areasId = this.sheng +','+ this.shilist[0].id
            this.mydata.areasName = this.userdata.areasName
        }
    }
  },
  methods: {
    resets(){
        this.$router.push('/refresh')
    },
      //   判断当前点击的按钮
    theBtn(i){
        if(i==1){
            if(this.btn.indexOf('classify:add')==-1){
                return this.$message('抱歉，用户暂无该权限')
            }
            this.handleEdit(0)
        }else if(i==2){
            if(this.btn.indexOf('classify:update')==-1){
                return this.$message('抱歉，用户暂无该权限')
            }
            if(this.multipleSelection.length != 1){
                return this.$message('请勾选一项内容编辑')
            }
            this.handleEdit(1,this.multipleSelection[0])
        }else if(i==3){
            if(this.btn.indexOf('classify:delete')==-1){
                return this.$message('抱歉，用户暂无该权限')
            }
            this.choice()
        }else if(i==4){
            this.query()
        }
    },
    // 获取省市传入的id
    gainSS(i){
        this.beginData.areaId = i.id
    },
      // 图标处理
    handleRemove(file, fileList) {
        this.mydata.iconUrl = ''
    },
    handleAvatarSuccess(res, file) {
        this.mydata.iconUrl = res.url
    },
      // 图片处理
    handleRemove1(file, fileList) {
        this.mydata.picUrl = ''
    },
    handleAvatarSuccess1(res, file) {
        this.mydata.picUrl = res.url
    },
    //   多选删除
    choice(){
        if(this.multipleSelection.length == 0){
            return this.$message('请至少选择一项删除')
        }
        let arr = []
        this.multipleSelection.forEach(x=>{
            arr.push(x.id)
        })
        this.$confirm('此操作将删除选中内容, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            let url = ``
            url = `/api-s/deleteGoodsCategory/${arr.join(',')}`
            this.$axios.post(url,{},{ headers: { accessToken: this.userdata.token }})
            .then(res=>{
                if(res.data.success==true){
                    this.$message({
                        type: 'success',
                        message: res.data.msg
                    });
                    this.begin();
                }else{
                    alert(res.data.msg)
                }
            })
        }).catch(() => {
            return
        });
    },
    // 关闭清空内容
    dataClose(){
        if(this.shilist.length==1){
            this.mydata={isShow:'true',areasId:this.sheng +','+ this.shilist[0].id,areasName:this.userdata.areasName}
        }else{
            this.shi = ''
            this.mydata={isShow:'true'}
        }
        this.begin()
    },
    cksheng(val){
        this.$set(this,'shi','')
    },
    ckshi(val){
        this.mydata.areasId = this.sheng +','+ val
        let arr = []
        this.shenglist.forEach(x=>{
            if(this.sheng==x.id){
                arr.push(x.name)
            }
        })
        this.shilist.forEach(x=>{
            if(val==x.id){
                this.mydata.pinyin = x.pinyin
                arr.push(x.name)
            }
        })
        this.mydata.areasName = arr.join(',')
    },
    //   多选编辑
    handleSelectionChange(val) {
        this.multipleSelection = val;
    },
    //   确定
    puton(){
        if(!this.mydata.areasId){
            return this.$message('请选择所属地区')
        }
        if(!this.mydata.name||this.mydata.name == "" || this.mydata.name.length < 1 ||!this.mydata.sortOrder||!this.mydata.picUrl||!this.mydata.iconUrl){
            return this.$message('请完善内容填写')
        }
        this.fullscreenLoading = true;
        // 判断是点击哪个
        let url = ``
        if(this.mydata.stat==0){
            url = `/api-s/addGoodsCategory`
        }else if(this.mydata.stat==1){
            url = `/api-s/updateGoodsCategory`
        }
        this.$axios.post(url,this.$qs.stringify(this.mydata),{ headers: { accessToken: this.userdata.token } })
        .then(res => {
            if(res.data.success){
                this.$message({
                    type: 'success',
                    message: res.data.msg
                });
                this.begin()
                this.dialogFormVisible = false
                this.$refs.upload.clearFiles();
                this.$refs.uploads.clearFiles();
            }else{
                this.$message({
                    message:res.data.msg,
                    type: 'warning'
                })
            }
        });
    },
    pag(val){
        this.pageNum = val.pageNum
        this.pageSize = val.pageSize
        this.fullscreenLoading = true;
        this.begin()
    },
    begin() {
      let userdata = JSON.parse(sessionStorage.getItem("userdata"));
      this.$set(this, "userdata", userdata);
      let data = this.$qs.stringify({
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        isShow:this.beginData.isShow,
        name:this.beginData.name,
        adminAreasId: userdata.areasId,
        areaId:this.beginData.areaId
      });
      this.$axios.post(`/api-s/getGoodsCategoryList`, data, {headers: { accessToken: userdata.token }})
        .then(res => {
            this.fullscreenLoading = false;
            if(res.data.success){
                this.$nextTick(function(){  //不使用this.$nextTick()方法会报错
                    this.$set(this, "tableData", res.data.pageInfo.list);
                });
                this.$set(this, "total", res.data.pageInfo.total);
                this.$message({
                    type: 'success',
                    message: res.data.msg
                });
            }else{
              this.$message(res.data.msg)
            }
        });
    },
    handleEdit(i,row,hint) {
        if(hint&&this.btn.indexOf(hint)==-1){
            return this.$message('抱歉，用户暂无该权限')
        }
        if(i == 0){
            this.mydata.stat = i
        }else if(i == 1){
            row.stat = i
            row.isShow+=''
            row.iconUrls = [{name:'分类图标',url:`${this.imgUrl+row.iconUrl}`}]
            row.picUrls = [{name:'分类图片',url:`${this.imgUrl+row.picUrl}`}]
            this.sheng = Number(row.areasId.split(',')[0])
            this.shi = Number(row.areasId.split(',')[1])
            this.mydata = row
        }
        this.dialogFormVisible = true
    },
    // 删除优惠券
    stop(row,hint) {
        if(hint&&this.btn.indexOf(hint)==-1){
            return this.$message('抱歉，用户暂无该权限')
        }
      this.$confirm('此操作将删除该条内容, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
          let url = ``
          url = `/api-s/deleteGoodsCategory/${row.id}`
          this.$axios.post(url,{},{ headers: { accessToken: this.userdata.token }})
          .then(res=>{
              if(res.data.success==true){
                  this.$message({
                      type: 'success',
                      message: res.data.msg
                  });
                  this.begin();
              }else{
                  alert(res.data.msg)
              }
          })
      }).catch(() => {
          return
      });
    },
    query() {
      this.fullscreenLoading = true;
      this.begin();
    }
  }
};
</script>
<style>
.w-e-toolbar{
  flex-wrap: wrap;
}
#classify .el-input__inner {
  margin: 10px 0;
}
#classify .el-menu.el-menu--horizontal{
  margin-bottom: 14px;
}
#classify .el-menu-item.is-active{
  background: none
}
#classify .el-pagination__sizes .el-input__inner {
  margin: 0;
}
#classify .el-tag{
  margin-right: 12px;
}
#classify .el-select {
  /* margin: 0 8px; */
  width: 50%
}
#classify .el-upload__tip {
    display: inline-block;
    margin-left: 14px;
}
.input-new-tag{
  width: 20%
}
#classify .el-upload-list--picture .el-upload-list__item {
    /* float: left;
    margin-right: 2%; */
}
#classify .el-form-item__content {
    width: 100%;
    display: flex;
}
#classify .el-table td,
.el-table th.is-leaf {
  text-align: center;
}
/* 暂无数据样式 */
#classify .el-table__empty-text {
  display: block;
  width: 500px;
  height: 240px;
  padding-top: 126px;
  background: url(../../assets/img/nothing.svg) no-repeat 50%;
  color: #909399;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-size: 12px;
}
#classify .myxx .el-input--suffix .el-input__inner {
  border-bottom: 1px solid #dcdfe6;
  margin-bottom: 20px;
}
#classify .myxx .el-input__inner {
  padding: 0 11px;
  border: none;
  border-radius: 0;
}
#classify .el-dialog__body {
  height: 100%;
}
#classify .el-form-item{
    display: flex;
    align-items: center;
    margin-bottom:0
}
#classify .el-form-item__label{
    width: 150px;
}
.viewer-transition {
  z-index: 9999 !important;
}
</style>
<style scoped lang="scss">
.clearfix{
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.tit {
  display: flex;
  justify-content: space-between;
  margin: 16px 0 24px;
}
.sfzimg {
  height: 48px;
}
#help .myxx p {
  margin: 5px 0;
  font-size: 16px;
}
h5 {
  text-align: center;
  margin-top: 12px;
}
.f56 {
  background: #909399;
  color: #fff;
  border: 1px solid #909399;
}
.c23 {
  background: #409eff;
  color: #fff;
  border: 1px solid #409eff;
}
.tx{
      color: red;
    margin-left: 8px;
}
.summary>span:first-child{
    margin-right: 20px
}
.summary>span:first-child i{
    color:red
}
.summary>span:last-child i{
    color:green
}
.staimg{
    position: absolute;
    left: -26px;
    top: 10px;
    width: 18px;
}
.dtstat span{
    margin: 0 34px;
}
</style>
